import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { QuotesSortOptionsType } from "@/Shared/Quotes/Types/QuotesSortOptionsType";

interface SortQuotesProps {
  sortBy: QuotesSortOptionsType;
  setSortBy: (_: QuotesSortOptionsType) => void;
}

export function QuotesSort(props: SortQuotesProps) {
  const { sortBy, setSortBy } = props;
  return (
    // Fixed width so the dropdown doesn't fall back to width:100% — this is
    // a compact, right-aligned control, not a full-width form field. The
    // quotes screen mounts no presentation provider, so pin the underlined
    // (Cargo) look this control has always had.
    <ControlPresentationProvider presentation="underlined">
      <div className="w-[240px] max-w-full">
        <Dropdown
          value={String(sortBy)}
          onChange={(v) => setSortBy(Number(v) as QuotesSortOptionsType)}
          placeholder="Sort quotes by"
          width="full"
          options={[
            {
              value: String(QuotesSortOptionsType.SortByLowestPrice),
              label: "Lowest Price",
            },
            {
              value: String(QuotesSortOptionsType.SortByFastestTime),
              label: "Fastest Transit Time",
            },
          ]}
        />
      </div>
    </ControlPresentationProvider>
  );
}
